import { render, staticRenderFns } from "./SysFornecedorAutocomplete.vue?vue&type=template&id=247dd814&scoped=true"
import script from "./SysFornecedorAutocomplete.vue?vue&type=script&lang=js"
export * from "./SysFornecedorAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./SysFornecedorAutocomplete.vue?vue&type=style&index=0&id=247dd814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247dd814",
  null
  
)

export default component.exports